import { createFileRoute } from '@tanstack/react-router'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { requireAuthenticatedSession } from '@/lib/require-auth'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    await requireAuthenticatedSession(location.href)
  },
  component: AuthenticatedLayout,
})
